export default "__VITE_ASSET__RFVmfJbL__"